import { cn } from "@/lib/cn";

/**
 * Dấu hiệu nhận diện của ZSchedule: một bong bóng tin nhắn phân phối tới nhiều
 * nhóm — đúng thứ sản phẩm này làm.
 *
 * Phải khớp với `public/favicon.svg`. Hình cố tình chỉ gồm hai khối đặc tách
 * bạch: ở 16px (cỡ thật trên tab trình duyệt) mọi chi tiết mảnh đều tan thành
 * vệt mờ, chỉ khối đặc mới giữ được hình.
 */
export function BrandMark({ className }: { className?: string }) {
    return (
        <svg
            viewBox="0 0 32 32"
            fill="currentColor"
            className={cn("size-full", className)}
            role="img"
            aria-label="ZSchedule"
        >
            <path d="M5 11a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H9l-4 3v-3.5A2 2 0 0 1 4 18v-7a2 2 0 0 1 1-2Z" />
            <path d="M18 7h3v18h-3ZM20 6.5h5v3h-5ZM20 14.5h5v3h-5ZM20 22.5h5v3h-5ZM25 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6ZM25 13a3 3 0 1 1 0 6 3 3 0 0 1 0-6ZM25 21a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z" />
        </svg>
    );
}
